const initStoreSelector = async () => {
  /*
  =========================================
  🤝🏼 Utility Functions
  =========================================
 */

  // 🤝🏼 UTILITY FUNCTION - [formatPhoneNumber] - Format a phone number to be more readable
  function formatPhoneNumber(phoneNumberString) {
    const cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      const intlCode = match[1] ? '+1 ' : ''
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
    }
    return null
  }

  // 🤝🏼 UTILITY FUNCTION - [updateLocationDisplay] - Update the store selector drawer with the latest location information
  function updateLocationDisplay(e, availableLocations = null) {
    const store_selector_locations = document.getElementById(
      'store-selector-locations'
    )
    // Get the data-my-store dataset from the store_selector_locations element
    const my_store_text = store_selector_locations.dataset.myStore
    const set_my_store_text = store_selector_locations.dataset.setMyStore
    const availText = {
      available: store_selector_locations.dataset.available,
      unavailable: store_selector_locations.dataset.unavailable,
      at: store_selector_locations.dataset.at
    }

    store_selector_locations.innerHTML = ''
    // Loop through each location and create a DOM element for it, then append it to the store selector drawer
    window.Scoutside.LocationState.locations.filter(location => location.pickup).forEach((location) => {
      const location_element = document.createElement('div')
      location_element.classList.add(
        'store-selector-location',
        'p-[18px]',
        'bg-white',
        'rounded-[3px]',
        '[&.selected_.current-store]:block',
        '[&.selected_.set-selected-store]:hidden'
      )
      location_element.dataset.store = location.id
      location_element.innerHTML = `
        <div class="store-selector-location__wrapper flex items-center gap-[35px] justify-between">
          <div class="store-selector-location__details text-[12px]">
            <div class="store-selector-location__name text-[14px] font-[600]">${
              location.name
            }</div>
            <div class="store-selector-location__address mt-2">
              ${
                location.address.address1 &&
                `<div>${location.address.address1}</div>`
              }
              ${
                location.address.address2 &&
                `<div>${location.address.address2}</div>`
              }
               ${
                 location.address.city &&
                 location.address.provinceCode &&
                 location.address.zip &&
                 `<div>${location.address.city} ${location.address.provinceCode} ${location.address.zip}</div>`
               }
               
               ${
                 location.address.phone &&
                 `<a href="tel:${
                   location.address.phone
                 }" class="flex mt-[13px] gap-[6px] items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <g id="Phone">
                        <path id="Vector" d="M12.6809 9.5747C12.5834 10.3157 12.2195 10.9959 11.6571 11.4883C11.0948 11.9806 10.3724 12.2514 9.625 12.25C5.28282 12.25 1.75 8.7172 1.75 4.37501C1.74867 3.62759 2.01944 2.90524 2.51177 2.34288C3.00409 1.78051 3.68429 1.41659 4.42532 1.31907C4.61271 1.29619 4.80247 1.33453 4.96628 1.42836C5.13009 1.52219 5.25916 1.66648 5.33422 1.8397L6.48922 4.41821V4.42478C6.54669 4.55737 6.57043 4.70213 6.55831 4.84613C6.54619 4.99013 6.49859 5.12889 6.41977 5.25001C6.40993 5.26478 6.39954 5.27845 6.3886 5.29212L5.25001 6.64181C5.65961 7.47415 6.53024 8.33712 7.37352 8.74782L8.70461 7.61525C8.71769 7.60426 8.73138 7.59403 8.74563 7.58462C8.86665 7.5039 9.00588 7.45463 9.15074 7.44126C9.29559 7.4279 9.44149 7.45085 9.57524 7.50806L9.58235 7.51134L12.1587 8.66579C12.3322 8.74059 12.4768 8.86955 12.571 9.03338C12.6651 9.19721 12.7037 9.38712 12.6809 9.5747Z" fill="#39825B"/>
                      </g>
                    </svg>
                    ${formatPhoneNumber(location.address.phone)}
                  </a>`
               }
            </div>
          </div>
          <div class="store-selector-location__actions flex-[0_0_105px] flex flex-col">
            <button class="current-store hidden bg-turf-green hover:bg-medium-green text-white not-italic cursor-pointer transition-colors py-[10px] px-[8px] rounded-[3px] text-[12px] font-[500] hover:font-[700] text-center">${my_store_text}</button>
            <button data-store="${
              location.id
            }" class="set-selected-store bg-white hover:bg-white text-off-black not-italic cursor-pointer border border-off-black inline-block transition-colors py-[10px] px-[8px] rounded-[3px] text-[12px] font-[500] hover:font-[700] text-center">${set_my_store_text}</button>
            ${availableLocations !== null ? `<p class="text-xs mt-3 lg:min-w-[134px]">
              ${availableLocations.includes(location.id)
                ? `<span class="text-turf-green">${availText.available}</span>`
                : `<span class="text-error">${availText.unavailable}</span>`
              } ${availText.at} ${location.name}
            </p>` : ''}
          </div>
        </div>
      `
      store_selector_locations.appendChild(location_element)
    })

    // 🖱 CLICK EVENT - [".set-selected-store"] - Set the selected store in the store selector drawer
    document.querySelectorAll('.set-selected-store').forEach((el) =>
      el.addEventListener('click', function (e) {
        window.Scoutside.LocationState.setSelectedLocation(
          e.target.dataset.store
        )
        window.Scoutside.LocationState.closeStoreSelectorDrawer()
      })
    )

    // Once we've populated all the locations, dispatch a setSelectedLocation event using the initial state value.
    window.Scoutside.LocationState.setSelectedLocation(
      window.Scoutside.LocationState.selectedLocation
    )
  }

  /*
    =========================================
    💻 Store Selector Drawer DOM Functionality
    =========================================
   */

  const html = document.getElementsByTagName('html')[0]
  const body = document.getElementsByTagName('body')[0]
  const store_selector_togglers = document.querySelectorAll(
    '.store-selector-toggler'
  )
  const store_selector_search_input = document.getElementById(
    'store-selector-search-input'
  )
  const store_selector_search_form = document.getElementById(
    'store-selector-search-form'
  )
  const set_current_location_to_zipcode_elements = document.querySelectorAll(
    '.set-current-location-to-zipcode'
  )
  // 👂 CUSTOM EVENT - [orderLocations] - Once locations are ordered, display them in the store selector drawer
  document.addEventListener(
    'orderLocations',
    updateLocationDisplay
  )

  // 👂 CUSTOM EVENT - [toggleStoreSelectorDrawer] - If the store selector is open, add the "store-selector-active" class to the body
  document.addEventListener('toggleStoreSelectorDrawer', function (e) {
    if (e.detail.availableLocations !== null) {
      updateLocationDisplay(e, e.detail.availableLocations)
    }

    if (e.detail.storeSelectorDrawerOpen) {
      html.classList.add('disable-scrolling')
      body.classList.add('store-selector-active')
    } else {
      html.classList.remove('disable-scrolling')
      body.classList.remove('store-selector-active')
    }
  })

  // 👂 CUSTOM EVENT - [setSelectedLocation] - Once a location is selected, add selected class to the selected location
  document.addEventListener('setSelectedLocation', function (e) {
    const selected_location = window.Scoutside.LocationState.selectedLocation

    if (selected_location) {
      const selected_location_display_elements = document.querySelectorAll(
        '.store-location-display'
      )
      const selected_province_display_elements = document.querySelectorAll(
        '.store-province-display'
      )
      const store_location_count_display_elements = document.querySelectorAll(
        '.store-location-count-display'
      )
      const store_location_searched_location_display_elements =
        document.querySelectorAll('.store-location-searched-location-display')

      // Remove the selected class from all locations, then add it to the selected location
      document
        .querySelectorAll('[data-store]')
        .forEach((el) => el.classList.remove('selected'))
      document
        .querySelector(`[data-store="${selected_location}"]`)
        .classList.add('selected')

      // Set the selected location display elements to the selected location
      window.Scoutside.LocationState.locations.forEach((location) => {
        if (selected_location === location.id) {
          selected_location_display_elements.forEach(
            (element) => (element.innerHTML = location.name)
          )

          selected_province_display_elements.forEach((element) => {
            element.innerHTML = `${location.address.city}, ${location.address.provinceCode}`
          })
        }
      })

      // Set the Search input to what we've set as the searched location
      store_selector_search_input.value =
        window.Scoutside.LocationState.searchedLocation

      // Update the store location count display elements
      store_location_count_display_elements.forEach(
        (element) =>
          (element.innerHTML = window.Scoutside.LocationState.locations.length)
      )

      // Update the store searched location display elements
      store_location_searched_location_display_elements.forEach(
        (element) =>
          (element.innerHTML = window.Scoutside.LocationState.searchedLocation)
      )
    }
  })

  // 👂 CUSTOM EVENT - [setLocationsFromAPI] - Once stores are fetched, display them in the store selector drawer
  document.addEventListener('setLocationsFromAPI', updateLocationDisplay)

  // 🖱 CLICK EVENT - [".store-selector-toggler"] - Toggle the store selector drawer
  store_selector_togglers.forEach((el) =>
    el.addEventListener(
      'click',
      window.Scoutside.LocationState.toggleStoreSelectorDrawer
    )
  )

  // 🖱 CLICK EVENT - [".set-current-location-to-zipcode"] - Set the searched location to the user's current zipcode
  set_current_location_to_zipcode_elements.forEach((el) =>
    el.addEventListener('click', function (e) {
      e.preventDefault()
      window.Scoutside.LocationState.setSortingMethod('coords')
      window.Scoutside.LocationState.setLocationInfoFromIPAddress()
        .then(() => {
          window.Scoutside.LocationState.setSearchedLocation(
            window.Scoutside.LocationState.zipcode
          )
        })
      
    })
  )

  // 📝 SUBMIT EVENT - ["#store-selector-search-form"] - Search for a location by zip code, city, or state
  store_selector_search_form.addEventListener('submit', function (e) {
    e.preventDefault()
    const search_query = store_selector_search_input.value ?? null
    window.Scoutside.LocationState.setSortingMethod('distanceMatrix')
    window.Scoutside.LocationState.setSearchedLocation(search_query)
  })
}
